import Vue from 'vue'
import VueNoty from 'vuejs-noty'
import Velocity from 'velocity-animate'
import 'velocity-animate/velocity.ui'

Vue.use(VueNoty, {
  theme: 'relax',
  timeout: 4500,
  progressBar: false,
  killer: true,
  animation: {
    open: function (promise) {
      Velocity(this.barDom, 'transition.slideRightIn', {
        duration: 500,
        complete: function () {
          promise(function (resolve) {
            resolve()
          })
        }
      })
    },

    close: function (promise) {
      Velocity(this.barDom, 'transition.slideRightOut', {
        duration: 500,
        complete: function () {
          promise(function (resolve) {
            resolve()
          })
        }
      })
    }
  }
})
